import { render, staticRenderFns } from "./RemindModal.vue?vue&type=template&id=63e6e695&lang=pug"
import script from "./RemindModal.vue?vue&type=script&lang=ts"
export * from "./RemindModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports